import React, { Component } from "react";
import { connect } from "react-redux";
import "./styles.css";
import KeyPatientInfoMiniCard from "../KeyPatientInfoMiniCard";
import PathologyInfoMiniCard from "../PathologyInfoMiniCard";
import PropTypes from "prop-types";
import { EMPTY_STRING } from "../../../constants";
import { setDownloadProperties } from "../../Home/actions";
import { If, Then } from "react-if";
import WarningTriangle from "../../__shared__/IconComponents/WarningTriangle";

class SummaryPanel extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.plan) {
            return;
        }

        let stubbedSummaryStyling = EMPTY_STRING;
        if (this.props.isFreehandPlan) {
            stubbedSummaryStyling = "summary-panel-stubbed-view";
        }

        return (
            <div className={"summary-panel-container"}>
                <If
                    condition={this.props.plan && this.props.plan.TreatmentPlan}
                >
                    <Then>
                        <div
                            className={`summary-panel ${stubbedSummaryStyling}`}
                        >
                            <KeyPatientInfoMiniCard />
                            <If condition={!this.props.isFreehandPlan}>
                                <Then>
                                    <PathologyInfoMiniCard />
                                    {this.props.cemWarningMsg && (
                                        <div
                                            id="step5-cem-warning"
                                            className="flex w-full items-start gap-2 p-4 text-sm text-(--avendaGray1)"
                                        >
                                            <WarningTriangle
                                                className="shrink-0 pt-1"
                                                width="21"
                                                height="19"
                                            />
                                            <span className="min-w-0 wrap-break-word">
                                                <span className="whitespace-nowrap">
                                                    Warning: {""}
                                                </span>
                                                {this.props.cemWarningMsg}
                                            </span>
                                        </div>
                                    )}
                                </Then>
                            </If>
                        </div>
                    </Then>
                </If>
            </div>
        );
    }
}

SummaryPanel.propTypes = {
    useruuid: PropTypes.string,
    authToken: PropTypes.string,
    visituuid: PropTypes.string,
    patientuuid: PropTypes.string,
    planuuid: PropTypes.string,
    isFreehandPlan: PropTypes.bool,
    plan: PropTypes.object,
    setDownloadProperties: PropTypes.func,
    cemWarningMsg: PropTypes.string,
};

SummaryPanel.defaultProps = {
    useruuid: EMPTY_STRING,
    authToken: EMPTY_STRING,
    visituuid: EMPTY_STRING,
    patientuuid: EMPTY_STRING,
    planuuid: EMPTY_STRING,
    plan: {},
    isFreehandPlan: false,
    cemWarningMsg: EMPTY_STRING,
};

/* istanbul ignore next */
const mapStateToProps = function (state) {
    return {
        useruuid: state.LoginReducer.useruuid,
        authToken: state.LoginReducer.authToken,
        visituuid: state.CreatePlanReducer.visituuid,
        patientuuid: state.CreatePlanReducer.patientuuid,
        planuuid: state.CreatePlanReducer.planuuid,
        plan: state.CreatePlanReducer.currentTreatmentPlan,
        downloadProperties: state.HomeReducer.downloadProperties,
    };
};

const mapDispatchToProps = function (dispatch) {
    return {
        setDownloadProperties: (selectOpen, patID, planID) =>
            dispatch(setDownloadProperties(selectOpen, patID, planID)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryPanel);
